import { useQuery } from '@tanstack/react-query';

import * as Api from 'contracts/api';
import fetch from 'modules/fetch';
import { useNotify } from 'pages/components/SnackBarProvider';
import { UseExposedQueryOptions } from 'queries/types';
import { getErrorMessage } from 'queries/utils';

enum Status {
    UNAUTHORIZED = 209
}

export class UnauthorizedError extends Error {}

export function useAiInsightsCounter<TData = Api.V4.Bulletins.AiInsightsCounter.Response>(
    options?: UseExposedQueryOptions<Api.V4.Bulletins.AiInsightsCounter.Response, Error, TData>
) {
    const notify = useNotify();

    return useQuery<Api.V4.Bulletins.AiInsightsCounter.Response, Error, TData>({
        ...options,
        queryKey: Api.V4.Bulletins.AiInsightsCounter.QueryKey(),
        queryFn: async ({ signal }) => {
            try {
                const response = await fetch(Api.V4.Bulletins.AiInsightsCounter.Endpoint(), {
                    signal,
                    headers: { ['Accept']: 'application/json' }
                });

                if (response.status === Status.UNAUTHORIZED) {
                    throw new UnauthorizedError('User is not authenticated');
                }

                return response.json().then(({ result }) => result);
            } catch (error) {
                notify.openNotification({ level: 'error', message: getErrorMessage(error) });
                throw error;
            }
        }
    });
}
